<!--
 * @Author:
 * @LastEditTime: 2022-04-19 12:03:43
 * @Description: 新增、编辑客户端
-->
<template>
  <div>
    <el-dialog
      v-dialogDrag
      width="1280px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :visible.sync="operateClientProps.visible"
      :title="operateClientProps.title"
      class="large-dialog"
    >
      <div class="content__dialog overflow-y-auto">
        <el-form
          size="mini"
          label-width="150px"
          :rules="clientRules"
          class="h-full"
          ref="clientForm"
          :model="clientForm"
          destroy-on-close
        >
          <el-tabs type="border-card" class="h-full" v-model="activeTabName">
            <el-tab-pane label="基本属性" name="0">
              <el-row :gutter="50">
                <el-col :span="12" v-if="operateClientProps.editType === 'create'">
                  <el-form-item label="客户端类型">
                    <el-select
                      filterable
                      clearable
                      v-model="clientType"
                      class="w-full"
                      size="small"
                    >
                      <el-option
                        v-for="item in clientTypes"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="客户端ID" prop="clientId">
                    <el-input
                      :readonly="operateClientProps.editType === 'edit'"
                      v-model="clientForm.clientId"
                      placeholder="请输入客户端id"
                      size="small"
                      clearable
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="显示名称" prop="clientName">
                    <el-input
                      v-model="clientForm.clientName"
                      placeholder="请输入客户端名称"
                      size="small"
                      clearable
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="启用" prop="enabled">
                    <el-checkbox v-model="clientForm.enabled" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="请求刷新令牌" prop="allowOfflineAccess">
                    <el-checkbox v-model="clientForm.allowOfflineAccess" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="operateClientProps.editType === 'edit'">
                  <el-form-item label="使用PKCE时用纯文本代码质询" prop="allowPlainTextPkce">
                    <el-checkbox v-model="clientForm.allowPlainTextPkce" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="客户端信息地址" prop="clientUri">
                    <el-input
                      v-model="clientForm.clientUri"
                      placeholder="请输入客户端信息地址"
                      size="small"
                      clearable
                      @blur="changeClientUrl"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="客户端logo地址" prop="logoUri">
                    <el-input
                      v-model="clientForm.logoUri"
                      placeholder="请输入客户端信息地址"
                      size="small"
                      clearable
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="允许的资源范围" prop="allowedScopes">
                    <el-select
                      size="small"
                      class="w-full"
                      filterable
                      clearable
                      multiple
                      v-model="clientForm.allowedScopes"
                      @change="changeAuthScopes"
                    >
                      <el-option
                        v-for="item in authScopes"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="允许使用的授权类型" prop="allowedGrantTypes">
                    <el-select
                      size="small"
                      filterable
                      multiple
                      clearable
                      v-model="clientForm.allowedGrantTypes"
                      class="w-full"
                      @change="changeAuthTypes"
                    >
                      <el-option
                        v-for="item in authTypes"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="描述" prop="description">
                    <el-input
                      type="textarea"
                      v-model="clientForm.description"
                      placeholder="请输入描述"
                      size="small"
                      clearable
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24" v-if="operateClientProps.editType === 'edit'">
                  <el-button type="primary" size="small" @click="addClaims()">添加声明集</el-button>
                </el-col>
              </el-row>
              <el-table
                :data="clientForm.claims"
                border
                class="mt-10px"
                height="140px"
                v-if="operateClientProps.editType === 'edit'"
              >
                <el-table-column label="类型" show-overflow-tooltip prop="type"></el-table-column>
                <el-table-column label="值" prop="value" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="120px">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="deleteClaim(scope.row)">删除声明</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="令牌配置" name="1">
              <el-row :gutter="50">
                <el-col :span="12" v-if="operateClientProps.editType === 'edit'">
                  <el-form-item label="SSO生命周期" prop="userSsoLifetime">
                    <el-input
                      v-model="clientForm.userSsoLifetime"
                      size="small"
                      type="number"
                      clearable
                    >
                      <template slot="append">秒</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="身份令牌生命周期" prop="identityTokenLifetime">
                    <el-input
                      v-model="clientForm.identityTokenLifetime"
                      size="small"
                      type="number"
                      clearable
                    >
                      <template slot="append">秒</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="访问令牌的生命周期" prop="accessTokenLifetime">
                    <el-input
                      v-model="clientForm.accessTokenLifetime"
                      size="small"
                      clearable
                      type="number"
                    >
                      <template slot="append">秒</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="授权码的生命周期" prop="authorizationCodeLifetime">
                    <el-input
                      type="number"
                      v-model="clientForm.authorizationCodeLifetime"
                      size="small"
                      filterable
                      clearable
                    >
                      <template slot="append">秒</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="刷新令牌的最大生命周期" prop="absoluteRefreshTokenLifetime">
                    <el-input
                      v-model="clientForm.absoluteRefreshTokenLifetime"
                      size="small"
                      filterable
                      clearable
                      type="number"
                    >
                      <template slot="append">秒</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="刷新令牌的滑动生命周期" prop="slidingRefreshTokenLifetime">
                    <el-input
                      v-model="clientForm.slidingRefreshTokenLifetime"
                      size="small"
                      filterable
                      clearable
                      type="number"
                    >
                      <template slot="append">秒</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="刷新令牌使用方式" prop="refreshTokenUsage">
                    <el-select
                      v-model="clientForm.refreshTokenUsage"
                      size="small"
                      class="w-full"
                      filterable
                      clearable
                    >
                      <el-option
                        :key="item.value"
                        v-for="item in refreshTokenTypes"
                        :value="item.value"
                        :label="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="刷新令牌过期方式" prop="refreshTokenExpiration">
                    <el-select
                      v-model="clientForm.refreshTokenExpiration"
                      size="small"
                      class="w-full"
                      filterable
                      clearable
                    >
                      <el-option
                        :key="item.value"
                        v-for="item in refreshTokenExpiredTypes"
                        :value="item.value"
                        :label="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="本地帐户登录" prop="enableLocalLogin">
                    <el-checkbox v-model="clientForm.enableLocalLogin" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="浏览器接收访问令牌" prop="allowAccessTokensViaBrowser">
                    <el-checkbox v-model="clientForm.allowAccessTokensViaBrowser" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="需要密钥从令牌站点请求令牌" prop="requireClientSecret">
                    <el-checkbox v-model="clientForm.requireClientSecret" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="必须发送证明密钥" prop="requirePkce">
                    <el-checkbox v-model="clientForm.requirePkce" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-button type="primary" size="small" @click="setSecret()">设置密钥</el-button>
                </el-col>
              </el-row>
              <el-table :data="clientForm.clientSecrets" border class="mt-10px" height="190px">
                <el-table-column
                  label="密钥值"
                  show-overflow-tooltip
                  prop="value"
                ></el-table-column>
                <el-table-column
                  label="描述"
                  prop="description"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column label="超时时间" prop="expiration" width="150px"></el-table-column>
                <el-table-column label="操作" width="120px">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="deleteSecret(scope.row)">删除密钥</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="地址配置" name="2">
              <el-table :data="clientForm.redirectUris" border class="mt-10px" height="300px">
                <el-table-column label="授权代码返回到的地址" prop="url">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.url"
                      size="small"
                      clearable
                      v-if="scope.row.editable"
                      @blur="saveRedirectUrl(scope.row)"
                    />
                    <span v-else>{{ scope.row.url }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="150px">
                  <template slot="header">
                    <el-button
                      type="primary"
                      class="vertical-middle iconfont icon-bg-add"
                      @click="addRedirectUrl()"
                      size="mini"
                    ></el-button>
                  </template>
                  <template slot-scope="scope">
                    <el-button size="mini" @click="editRedirecturl(scope.row)">编辑</el-button>
                    <el-button size="mini" @click="deleteRedirecturl(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-table
                :data="clientForm.postLogoutRedirectUris"
                border
                height="300px"
                class="mt-10px"
              >
                <el-table-column label="注销后允许重定向到的地址集" prop="url">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.url"
                      size="small"
                      clearable
                      v-if="scope.row.editable"
                      @blur="saveLogoutRedirectUrl(scope.row)"
                    />
                    <span v-else>{{ scope.row.url }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="150px">
                  <template slot="header">
                    <el-button
                      size="mini"
                      type="primary"
                      class="vertical-middle iconfont icon-bg-add"
                      @click="addLogoutRedirectUrl()"
                    ></el-button>
                  </template>
                  <template slot-scope="scope">
                    <el-button size="mini" @click="editLogoutRedirecturl(scope.row)"
                      >编辑</el-button
                    >
                    <el-button size="mini" @click="deleteLogoutRedirecturl(scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-form>
      </div>
      <div slot="footer" class="flex justify-center">
        <el-button size="small" type="primary" class="iconfont icon-save" @click="save()"
          >保存</el-button
        >
        <el-button size="small" class="iconfont icon-close" @click="cancel()">取消</el-button>
      </div>
    </el-dialog>
    <!-- 设置密钥 start -->
    <el-dialog :visible.sync="setSecretVisible" title="设置密钥" width="600px">
      <el-form :model="secretForm" :rules="secretRules" label-width="120px" ref="secretForm">
        <el-form-item label="密钥值" prop="value">
          <el-input v-model="secretForm.value" placeholder="请输入密钥值" size="small" clearable />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            v-model="secretForm.description"
            placeholder="请输入描述"
            size="small"
            clearable
          />
        </el-form-item>
        <el-form-item label="超时时间" prop="expiration">
          <el-date-picker
            class="!w-full"
            size="small"
            v-model="secretForm.expiration"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center">
        <el-button size="small" type="primary" class="iconfont icon-save" @click="saveSecret()"
          >保存</el-button
        >
        <el-button size="small" class="iconfont icon-close" @click="setSecretVisible = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
    <!-- 设置密钥 end -->
    <!-- 添加声明集 start -->
    <el-dialog :visible.sync="addClaimsVisible" title="添加声明集" width="600px">
      <el-form :model="claimForm" :rules="claimFormRules" label-width="120px" ref="claimForm">
        <el-form-item label="声明类型" prop="type">
          <el-input v-model="claimForm.type" placeholder="请输入声明类型" size="small" clearable />
        </el-form-item>
        <el-form-item label="声明值" prop="value">
          <el-input v-model="claimForm.value" placeholder="请输入声明值" size="small" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center">
        <el-button size="small" type="primary" class="iconfont icon-save" @click="saveClaim()"
          >保存</el-button
        >
        <el-button size="small" class="iconfont icon-close" @click="addClaimsVisible = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
    <!-- 添加声明集 end -->
  </div>
</template>

<script>
import { ClientApi } from '@wiz-api/auth-server'
import { ClaimTypeApi } from '@wiz-api/account'
import dayjs from 'dayjs'

const clientApi = new ClientApi()
const claimTypeApi = new ClaimTypeApi()

export default {
  name: 'operateApiDialog',
  props: {
    operateClientProps: {
      type: Object,
      default: () => {
        return {
          title: '新增客户端',
          editType: 'create',
          visible: false,
        }
      },
    },
    clientForm: {
      type: Object,
      default: () => {
        return {
          enabled: false,
          clientName: '',
          clientUri: '',
          logoUri: '',
          description: '',
          allowedScopes: [],
          allowedGrantTypes: [],
          redirectUris: [],
          postLogoutRedirectUris: [],
          allowOfflineAccess: false,
          identityTokenLifetime: 300, // 默认值
          accessTokenLifetime: 3600, // 默认值
          authorizationCodeLifetime: 300, // 默认值
          absoluteRefreshTokenLifetime: 2592000, // 默认值
          slidingRefreshTokenLifetime: 1296000, // 默认值
          refreshTokenUsage: 1, // 默认值
          refreshTokenExpiration: 1, // 默认值
          enableLocalLogin: false,
          clientId: '',
          clientSecrets: [],
          allowAccessTokensViaBrowser: false,
          requireClientSecret: true, // 默认true
          requirePkce: true, // 默认为true
          userSsoLifetime: null,
          claims: [],
        }
      },
    },
  },
  watch: {
    clientType(type) {
      // 客户端类型为空 或 客户端信息地址为空 不处理
      if (!type || _.isEmpty(this.clientForm.clientUri)) {
        return
      }
      this.watchClientType(type)
    },
    setSecretVisible(bol) {
      if (bol) {
        this.secretForm = this.$options.data().secretForm
      }
    },
    operateClientProps: {
      deep: true,
      immediate: true,
      handler(props) {
        if (props.visible) {
          this.activeTabName = '0'
          if (props.editType === 'edit') {
            this.changeAuthScopes(this.clientForm.allowedScopes)
            this.changeAuthTypes(this.clientForm.allowedGrantTypes)
          }
        }
      },
    },
  },
  components: {},
  data() {
    const authTypes = [
      'implicit',
      'client_credentials',
      'authorization_code',
      'hybrid',
      'password',
      'urn:ietf:params:oauth:grant-type:device_code',
      'delegation',
      'loginby_username'
    ]
    return {
      urlReg: /(http|https):\/\/([\w.]+\/?)\S*/,
      clientType: '',
      clientTypes: [
        {
          name: 'Swagger',
          value: 1,
        },
        {
          name: 'SPA',
          value: 2,
        },
        {
          name: 'Web应用',
          value: 3,
        },
      ],
      claimTypes: [], // 声明集
      initClaimTypes: [], // 初始化所有的声明集
      activeTabName: '0',
      secretForm: {
        type: 'SharedSecret',
        value: '',
        description: '',
        expiration: '',
      },
      setSecretVisible: false,
      claimFormRules: {
        type: [
          {
            required: true,
            message: '请输入声明类型',
            trigger: 'blur',
          },
        ],
        value: [
          {
            required: true,
            message: '请输入声明值',
            trigger: 'blur',
          },
        ],
      },
      secretRules: {
        value: [
          {
            required: true,
            message: '请输入密钥值',
            trigger: 'blur',
          },
        ],
      },
      refreshTokenTypes: [
        {
          name: 'OneTime',
          value: 1,
        },
        {
          name: 'ReUse',
          value: 0,
        },
      ],
      refreshTokenExpiredTypes: [
        {
          name: 'Absolute',
          value: 1,
        },
        {
          name: 'Sliding',
          value: 0,
        },
      ],
      authTypes,
      initAuthTypes: _.cloneDeep(authTypes),
      authScopes: [], // 授权范围
      initAuthScopes: [], // 初始化的授权范围
      clientRules: {
        clientName: [
          {
            required: true,
            message: '请输入客户端名称',
            trigger: 'blur',
          },
        ],
        allowedGrantTypes: [
          {
            required: true,
            message: '请选择允许使用的授权类型',
            trigger: 'blur',
          },
        ],
        clientId: [
          {
            required: true,
            message: '请输入客户端ID',
            trigger: 'blur',
          },
        ],
      },
      redirectUrl: '', // 通过配置设置授权代码返回地址
      postLogoutRedirectUrl: '', // 通过配置设置注销后允许重定向地址
      addClaimsVisible: false, // 添加声明集visible
      claimForm: {
        type: '',
        value: '',
      },
    }
  },
  computed: {},
  created() {
    this.getAuthScopes()
    this.findClaimTypes()
  },
  methods: {
    deleteClaim(row) {
      this.$confirm('确认要删除么', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.clientForm.claims = _.difference(this.clientForm.claims, [row])
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    saveClaim() {
      this.$refs.claimForm.validate((valid) => {
        if (valid) {
          this.clientForm.claims.push(_.cloneDeep(this.claimForm))
          this.addClaimsVisible = false
        }
      })
    },
    // 改变声明
    changeClaims(claims) {
      console.log(claims, 'claims')
      this.claimTypes = _.filter(this.initClaimTypes, (item) => {
        return !_.includes(claims, item.id)
      })
    },
    // 编辑授权代码返回地址
    editRedirecturl(row) {
      this.$set(row, 'editable', true)
    },
    // 保存授权代码返回的地址
    saveRedirectUrl(row) {
      this.$set(row, 'editable', false)
    },
    // 编辑注销后允许重定向地址
    editLogoutRedirecturl(row) {
      this.$set(row, 'editable', true)
    },
    // 保存注销后允许重定向的地址
    saveLogoutRedirectUrl(row) {
      this.$set(row, 'editable', false)
    },
    watchClientType(type) {
      // 监听客户端类型
      switch (type) {
        case 1: // Swagger
          this.configPrimarySwaggerValue()
          break
        case 2: // SPA
          this.configPrimarySpaValue()
          break
        case 3: // web应用
          this.configPrimaryWebValue()
          break
        default:
          break
      }
    },
    // 改变客户端信息地址
    changeClientUrl() {
      if (!this.clientForm.clientUri) {
        return
      }
      if (!this.urlReg.test(this.clientForm.clientUri)) {
        this.$message.warning({
          showClose: true,
          message: '输入地址不合法',
        })
        this.clientForm.clientUri = ''
        return
      }
      if (!this.clientType) {
        return
      }
      this.watchClientType(this.clientType)
    },
    // 配置web应用默认值
    configPrimaryWebValue() {
      this.$set(this.clientForm, 'allowedGrantTypes', [
        'password',
        'client_credentials',
        'authorization_code',
      ])
      this.$set(this.clientForm, 'allowAccessTokensViaBrowser', true)
      this.$set(this.clientForm, 'requireClientSecret', false)
      this.removeConfigUrl()
      // 授权代码返回地址
      this.redirectUrl = this.clientForm.clientUri
      const existRedirectUrl = _.find(this.clientForm.redirectUris, ['url', this.redirectUrl])
      // 去重
      if (_.isNil(existRedirectUrl)) {
        this.clientForm.redirectUris.push({
          url: this.redirectUrl,
        })
      }
      // 注销后允许重定向地址
      this.postLogoutRedirectUrl = this.clientForm.clientUri
      const existPostLogoutRedirectUrl = _.find(this.clientForm.postLogoutRedirectUris, [
        'url',
        this.postLogoutRedirectUrl,
      ])
      if (_.isNil(existPostLogoutRedirectUrl)) {
        this.clientForm.postLogoutRedirectUris.push({
          url: this.postLogoutRedirectUrl,
        })
      }
    },
    // 配置spa默认值
    configPrimarySpaValue() {
      this.$set(this.clientForm, 'allowedGrantTypes', ['implicit'])
      this.$set(this.clientForm, 'allowAccessTokensViaBrowser', true)
      // 授权代码返回地址
      this.removeConfigUrl()
      this.redirectUrl = `${this.clientForm.clientUri}/callBack.html`
      const existRedirectUrl = _.find(this.clientForm.redirectUris, ['url', this.redirectUrl])
      // 去重
      if (_.isNil(existRedirectUrl)) {
        this.clientForm.redirectUris.push({
          url: this.redirectUrl,
        })
      }
      // 注销后允许重定向地址
      this.postLogoutRedirectUrl = `${this.clientForm.clientUri}/#/`
      const existPostLogoutRedirectUrl = _.find(this.clientForm.postLogoutRedirectUris, [
        'url',
        this.postLogoutRedirectUrl,
      ])
      if (_.isNil(existPostLogoutRedirectUrl)) {
        this.clientForm.postLogoutRedirectUris.push({
          url: this.postLogoutRedirectUrl,
        })
      }
    },
    removeConfigUrl() {
      // 移除配置过的url
      if (this.redirectUrl) {
        const existRedirectUrlRow = _.find(this.clientForm.redirectUris, ['url', this.redirectUrl])
        this.clientForm.redirectUris = _.difference(this.clientForm.redirectUris, [
          existRedirectUrlRow,
        ])
      }
      if (this.postLogoutRedirectUrl) {
        const existPostLogoutRedrectUrlRow = _.find(this.clientForm.postLogoutRedirectUris, [
          'url',
          this.postLogoutRedirectUrl,
        ])
        this.clientForm.postLogoutRedirectUris = _.difference(
          this.clientForm.postLogoutRedirectUris,
          [existPostLogoutRedrectUrlRow]
        )
      }
    },
    // 配置swagger默认值
    configPrimarySwaggerValue() {
      this.$set(this.clientForm, 'allowedGrantTypes', ['authorization_code'])
      this.$set(this.clientForm, 'allowAccessTokensViaBrowser', false)
      this.removeConfigUrl()
      this.redirectUrl = `${this.clientForm.clientUri}/swagger/oauth2-redirect.html`
      const existRedirectUrl = _.find(this.clientForm.redirectUris, ['url', this.redirectUrl])
      // 去重
      if (existRedirectUrl) {
        return
      }
      this.clientForm.redirectUris.push({
        url: this.redirectUrl,
      })
    },
    async findClaimTypes() {
      this.formLoading = true
      const [err, res] = await claimTypeApi.getAllList()
      this.formLoading = false
      if (!err) {
        this.claimTypes = res
        this.initClaimTypes = _.cloneDeep(this.claimTypes)
      }
    },
    /**
     * @description: 添加授权代码返回地址
     * @param {*}
     * @return {*}
     */
    addRedirectUrl() {
      this.$prompt('请输入地址', '添加授权代码返回地址', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /(http|https):\/\/([\w.]+\/?)\S*/,
        inputErrorMessage: '地址格式不正确',
      }).then(({ value }) => {
        this.clientForm.redirectUris.push({
          url: value,
        })
      })
    },
    /**
     * @description: 删除授权代码返回地址
     * @param {*} row
     * @return {*}
     */
    deleteRedirecturl(row) {
      this.$confirm('确认要删除么', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        this.clientForm.redirectUris = _.difference(this.clientForm.redirectUris, [row])
      })
    },
    /**
     * @description: 删除注销后允许重定向到的地址
     * @param {*} row
     * @return {*}
     */
    deleteLogoutRedirecturl(row) {
      this.$confirm('确认要删除么', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        this.clientForm.postLogoutRedirectUris = _.difference(
          this.clientForm.postLogoutRedirectUris,
          [row]
        )
      })
    },
    addClaims() {
      // 添加声明
      this.addClaimsVisible = true
      this.$nextTick(() => {
        this.$refs.claimForm.resetFields()
      })
    },
    /**
     * @description: 添加注销后重定向地址
     * @param {*}
     * @return {*}
     */
    addLogoutRedirectUrl() {
      this.$prompt('请输入地址', '添加注销后重定向地址', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /(http|https):\/\/([\w.]+\/?)\S*/,
        inputErrorMessage: '地址格式不正确',
      }).then(({ value }) => {
        this.clientForm.postLogoutRedirectUris.push({
          url: value,
        })
      })
    },
    /**
     * @description: 获取授权范围
     * @param {*}
     * @return {*}
     */
    async getAuthScopes() {
      const [err, res] = await clientApi.searchConsts({ type: 'scope' })
      if (!err) {
        this.authScopes = res
        this.initAuthScopes = _.cloneDeep(this.authScopes)
        if (this.operateClientProps.editType === 'edit') {
          this.changeAuthTypes(this.clientForm.allowedGrantTypes)
        }
        this.changeAuthScopes(this.clientForm.allowedScopes)
      }
    },
    // 修改授权范围
    changeAuthScopes(scopes) {
      // this.authScopes = _.filter(this.initAuthScopes, (item) => {
      //   return !_.includes(scopes, item)
      // })
    },
    changeAuthTypes(types) {
      this.authTypes = _.filter(this.initAuthTypes, (item) => {
        return !_.includes(types, item)
      })
    },
    /**
     * @description: 删除密钥
     * @param {*}
     * @return {*}
     */
    deleteSecret(row) {
      this.$confirm('确认要删除么', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          console.log(this.operateClientProps, 'applicationProps')
          if (this.operateClientProps.editType === 'edit') {
            const [err, res] = await clientApi.removeSeccret(this.clientForm.id, {
              ...row,
            })
            if (!err) {
              this.clientForm.clientSecrets = _.difference(this.clientForm.clientSecrets, [row])
              this.$message.success({
                showClose: true,
                message: '删除成功',
              })
            }
            return
          }
          this.clientForm.clientSecrets = _.difference(this.clientForm.clientSecrets, [row])
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    /**
     * @description: 保存密钥
     * @param {*}
     * @return {*}
     */
    saveSecret() {
      this.$refs.secretForm.validate(async (valid) => {
        if (valid) {
          const createSecret = _.cloneDeep(this.secretForm)
          createSecret.expiration = createSecret.expiration
            ? dayjs(createSecret.expiration).format('YYYY-MM-DD HH:mm:ss')
            : ''
          if (this.operateClientProps.editType === 'edit') {
            const [err, res] = await clientApi.addSecret(this.clientForm.id, {
              body: createSecret,
            })
            if (!err) {
              this.$message.success({
                showClose: true,
                message: '新增密钥成功',
              })
            }
          }
          this.clientForm.clientSecrets.push(createSecret)
          this.setSecretVisible = false
        }
      })
    },
    /**
     * @description: 设置密钥
     * @param {*}
     * @return {*}
     */
    setSecret() {
      this.setSecretVisible = true
    },
    cancel() {
      this.operateClientProps.visible = false
    },
    save() {
      this.$refs.clientForm.validate(async (valid) => {
        if (valid) {
          const reqData = _.cloneDeep(this.clientForm)
          reqData.postLogoutRedirectUris = _.map(reqData.postLogoutRedirectUris, 'url')
          reqData.redirectUris = _.map(reqData.redirectUris, 'url')
          if (this.operateClientProps.editType === 'create') {
            const [err, res] = await clientApi.create({ body: reqData })
            if (!err) {
              this.$message.success({
                showClose: true,
                message: '新增成功',
              })
              this.operateClientProps.visible = false
              this.$emit('refreshList')
            }
            return
          }
          const [updateErr, updateRes] = await clientApi.update(reqData.id, {
            body: reqData,
          })
          if (!updateErr) {
            this.$message.success({
              showClose: true,
              message: '修改成功',
            })
            this.operateClientProps.visible = false
            this.$emit('refreshList')
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.item__secret {
  width: calc(100% - 90px);
}
.content__dialog {
  height: 700px;
}
::v-deep .el-tabs__content {
  height: calc(100% - 38px);
  overflow-y: auto;
}
</style>
